import moment from 'moment';
import { capitaliseString } from 'utils/helperMethods';
function PaymentGatewayCredentialList(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}
PaymentGatewayCredentialList.prototype = Object.assign(
    PaymentGatewayCredentialList.prototype,
    {
        createTableData(tableData) {
            if (
                tableData &&
                tableData.viewList &&
                tableData.viewList.length > 0
            ) {
                return tableData.viewList.map(row => this.createRow(row));
            }
            return [];
        },
        createPaginationData(data) {
            if (data) {
                const {
                    pageNumber,
                    pageSize,
                    totalElements,
                    totalNumberOfPages,
                    hasNextPage,
                    hasPreviousPage,
                } = data;
                return {
                    hasNextPage,
                    hasPreviousPage,
                    pageNumber,
                    pageSize,
                    totalNumberOfPages,
                    totalNumberOfRecords:totalElements,
                };
            }
            return {};
        },
        createRow(row) {
            const {
                pgMid,
                pgMerchantCode,
                pgName,
                category,
                status,
                mcc,
                lastUpdatedDate,
                lastUpdatedBy,
            } = row;
            const capitalisedCategory = capitaliseString(category);
            const capitalisedUser = capitaliseString(lastUpdatedBy);
            return {
                credentialId: pgMerchantCode,
                pgMid,
                pgName,
                category: capitalisedCategory,
                mcc,
                status,
                lastUpdatedDate: this.formatData(lastUpdatedDate),
                lastUpdatedBy: capitalisedUser,
            };
        },
        formatData(date) {
            return moment(date).format('DD/MM/YYYY');
        },
    }
);
export default PaymentGatewayCredentialList;
